import React from 'react';
import { t } from 'Src/i18n';
import { Badge } from 'Components/frameworks/badge/Badge';
import { ICONS } from 'Components/utils/icon/icons';
export const OptionBlock = () => (
  <div
    data-testid="OptionBlock"
    className="mb-20 h-full rounded-12 border-1 border-lightGrey bg-white p-20"
  >
    <div className="flex items-start gap-20">
      <Badge
        className="size-48 border-lightSand bg-lightSand text-black"
        iconName={ICONS.CALENDAR_OPTION}
        variant="pill"
      />
      <div className="text-start">
        <p className="text-16 font-semibold leading-normal">
          {t('booking.priceDetails.optionTitle')}
        </p>
        <p className="mt-8 text-14 leading-normal">{t('booking.priceDetails.optionDescription')}</p>
      </div>
    </div>
  </div>
);
